import Information from "./information/container";

const index = () => {
  return (
    <>
      <Information />
    </>
  );
};

export default index;
